
import axios, { AxiosResponse } from 'axios';
import {Response, ApiResponse} from '../../../interface/IResponse';
import {ResponseCreateMember, MemberTabDetails, ResponseMemberTabDetails, 
        RequestMembersRegistryFirstTabUpdate, RequestMembersRegistryFirstTab, 
        RequestMembersRegistrySecondTab, RequestMembersRegistryThirdTab, ResponseMembersRegistryTableData,
        ResponseDepartmentsList, ResponseDepartment} from '../../../interface/IMembersRegistry';





async function getMemberDetailFunction(memberId: number) : Promise<AxiosResponse<ResponseMemberTabDetails>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Members/Client/getMemberDetail";

        const response: AxiosResponse<ResponseMemberTabDetails> = await axios.get<ResponseMemberTabDetails>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function listDepartmentsFunction() : Promise<AxiosResponse<ResponseDepartmentsList>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/departments/list";

        const response: AxiosResponse<ResponseDepartmentsList> = await axios.get<ResponseDepartmentsList>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function getDepartmentByIdFunction(departmentId: number) : Promise<AxiosResponse<ResponseDepartment>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/departments/${departmentId}`;

        const response: AxiosResponse<ResponseDepartment> = await axios.get<ResponseDepartment>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){

        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

async function getCivilStatusDisplayNameByValueFunction(civilStatusValue: number): Promise<AxiosResponse<ApiResponse<string>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/Members/getCivilStatusNameByValue/${civilStatusValue}`;

        const response: AxiosResponse<ApiResponse<string>> = await axios.get<ApiResponse<string>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(err){
        throw err;

    }
}


const membersDetailsService = {
    getMemberDetail: getMemberDetailFunction,
    listDepartments: listDepartmentsFunction,
    getDepartmentById : getDepartmentByIdFunction,
    getCivilStatusDisplayNameByValue: getCivilStatusDisplayNameByValueFunction
}

export default membersDetailsService;